var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropzoneImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.4426 66.8333H19.5538C8.25616 66.8333 0.666504 58.9096 0.666504 47.1142V19.889C0.666504 8.09367 8.25616 0.166626 19.5538 0.166626H48.4459C59.7435 0.166626 67.3332 8.09367 67.3332 19.889V47.1142C67.3332 58.9096 59.7435 66.8333 48.4426 66.8333Z",
    fill: "#FFB1B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4833 22.4167C31.4833 26.9833 27.7667 30.7 23.2 30.7C18.63 30.7 14.9167 26.9833 14.9167 22.4167C14.9167 17.85 18.63 14.13 23.2 14.13C27.7667 14.13 31.4833 17.85 31.4833 22.4167ZM58.668 40.4587C59.4447 41.212 60.0013 42.072 60.368 42.9887C61.478 45.762 60.9013 49.0953 59.7147 51.842C58.308 55.112 55.6147 57.582 52.2213 58.662C50.7147 59.1453 49.1347 59.352 47.558 59.352H19.6213C16.8413 59.352 14.3813 58.7053 12.3647 57.492C11.1013 56.732 10.878 54.982 11.8147 53.842C13.3813 51.942 14.928 50.0353 16.488 48.112C19.4613 44.432 21.4647 43.3653 23.6913 44.302C24.5947 44.6887 25.5013 45.272 26.4347 45.8853C28.9213 47.532 32.378 49.792 36.9313 47.3387C40.0437 45.6368 41.8504 42.7246 43.423 40.1898L43.4547 40.1387C43.5605 39.9691 43.6654 39.7995 43.77 39.6305C44.3047 38.7664 44.8314 37.9154 45.428 37.132C46.168 36.162 48.9147 33.1287 52.4647 35.2887C54.728 36.6487 56.6313 38.4887 58.668 40.4587Z",
    fill: "#C30F0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzoneImg);
export default __webpack_public_path__ + "static/media/dropzoneImg.8ac238600c705874d6394b85af7d9d58.svg";
export { ForwardRef as ReactComponent };